import { createFileRoute } from '@tanstack/react-router'
import { DataMigration } from '@/features/data-migration'

export const Route = createFileRoute(
  '/_authenticated/_organization/organizations/settings/data-migration',
)({
  component: DataMigration,
})
